import AuctionBiddingModal from '../src/AuctionBiddingModal';
export default AuctionBiddingModal;
